"use client";

import React, { useEffect } from "react";

import { usePlatformStore } from "@/entities/platform";
import { parseAsString, useQueryStates } from "nuqs";

type Props = {
  children: React.ReactNode;
};

const PlatformProvider: React.FC<Props> = ({ children }) => {
  const { initFromUrl, isInitialized } = usePlatformStore();

  const [query, setQuery] = useQueryStates(
    {
      token: parseAsString,
      lat: parseAsString,
      long: parseAsString,
      address: parseAsString,

      client_id: parseAsString,
      client_phone: parseAsString,
      client_email: parseAsString,

      reception_phone: parseAsString,
      room_number: parseAsString,

      source: parseAsString,
    },
    {
      history: "replace",
    },
  );
  useEffect(() => {
    if (isInitialized) return;
    if (!query.source) return;

    const client_phone = "+" + query.client_phone;
    const reception_phone = "+" + query.reception_phone;

    // ✅ save into zustand persist
    initFromUrl({ ...query, client_phone, reception_phone });

    // ✅ clear only these params from URL
    setQuery({
      token: null,
      lat: null,
      long: null,
      address: null,

      client_id: null,
      client_phone: null,
      client_email: null,

      reception_phone: null,
      room_number: null,

      source: null,
    });
  }, [isInitialized, initFromUrl, query, setQuery]);

  return <>{children}</>;
};

export default PlatformProvider;
